const passwordPolicy = {
  MIN_LENGTH: {
    rule: 6,
    message: 'Password must be at least 6 characters long'
  },
  MAX_LENGTH: {
    rule: 15,
    message: 'Password must be no more than 15 characters long'
  },
  NON_REPEATING: {
    message: 'Password must have no repeating characters'
  },
  // UPPERCASE_MIN_COUNT: {
  //   rule: 0,
  //   message: 'Password must include at least 0 uppercase letter'
  // },
  // LOWERCASE_MIN_COUNT: {
  //   rule: 0,
  //   message: 'Password must include at least 0 lowercase letter'
  // },
  // NUMBER_MIN_COUNT: {
  //   rule: 0,
  //   message: 'Password must include at least 0 number'
  // },
  // SPECIAL_CHAR_MIN_COUNT: {
  //   rule: 0,
  //   message: 'Password must at least 0 special character'
  // },
  BLACKLIST: {
    rule: [
      '234567',
      '765432',
      '345678',
      '876543',
      '456789',
      '987654',
      '543210',
      '012345',
      'chanel',
      'lenahc',
      '123456',
      'password',
      '12345678',
      'qwerty',
      '123456789',
      '12345',
      '1234',
      '111111',
      '1234567',
      'dragon',
      '123123',
      'baseball',
      'abc123',
      'football',
      'monkey',
      'letmein',
      '696969',
      'shadow',
      'master',
      '666666',
      'qwertyuiop',
      '123321',
      'mustang',
      '1234567890',
      'michael',
      '654321',
      'pussy',
      'superman',
      '1qaz2wsx',
      '7777777',
      'fuckyou',
      '121212',
      '000000',
      'qazwsx',
      '123qwe',
      'killer',
      'trustno1',
      'jordan',
      'jennifer',
      'zxcvbnm',
      'asdfgh',
      'hunter',
      'buster',
      'soccer',
      'harley',
      'batman',
      'andrew',
      'tigger',
      'sunshine',
      'iloveyou',
      'fuckme',
      '2000',
      'charlie',
      'robert',
      'thomas',
      'hockey',
      'ranger',
      'daniel',
      'starwars',
      'klaster',
      '112233',
      'george',
      'asshole',
      'computer',
      'michelle',
      'jessica',
      'pepper',
      '1111',
      'zxcvbn',
      '555555',
      '11111111',
      '131313',
      'freedom',
      '777777',
      'pass',
      'fuck',
      'maggie',
      '159753',
      'aaaaaa',
      'ginger',
      'princess',
      'joshua',
      'cheese',
      'amanda',
      'summer',
      'love',
      'ashley',
      '6969',
      'nicole',
      'chelsea',
      'biteme',
      'matthew',
      'access',
      'yankees',
      '987654321',
      'dallas',
      'austin',
      'thunder',
      'taylor',
      'matrix'
    ],
    message: 'Password is not secure enough'
  }
}

export default passwordPolicy



// WEBPACK FOOTER //
// ./src/passwordPolicy.config.js